module.exports = __webpack_public_path__ + "static/media/empty-placeholder-bw.14c1248e.jpg";